import UserPersistence from "@/persistence/UserPersistence";
export const moduleId = 'wages';

export const state = {
    orgId: UserPersistence.getOrgId(),
    isShow: true,
    wagesDetails: '',
    wagesId: '',
    abId: '',
    accountInfo: {},
    routerUrl: '',
    isView: false,
    disable: false,
    buttonType: '',
    params: null,
    billCode: ''
}
export const mutations = {
    setWagesDetails(state, data) {
        state.wagesDetails = data
    },
    setWagesIsShow(state, flag) {
        state.isShow = flag
    },
    setOrgId(state, id) {
        state.orgId = id
    },
    setWagesId(state, data) {
        state.wagesId = data.id
        state.abId = data.abId
    },
    setAccountInfo(state, data) {
        state.accountInfo = data
    },
    setWagesRouterUrl(state, url) {
        state.routerUrl = url
    },
    setWagesIsView(state, flag) {
        state.isView = flag
    },
    setWagesDisable(state, flag) {
        state.disable = flag
    },
    setButtonType(state, type) {
        state.buttonType = type
    },

    setParams(state, data) {
        state.params = data
    },
    setBillCode(state, code) {
        state.billCode = code
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/wages/index.js